import { computed, ComputedRef } from "vue";
import { storeToRefs } from "pinia";
import { useTasksStore } from "@/stores/v2";
import { Tank, TaskTankAttribute } from "@/types/v2";
import { isEnvAttrsModifierTask } from "@/stores/v2/sites/utils";

export function useEnvAttrsModifier() {
  // ===================================================================
  // Store
  // ===================================================================
  const { activeTask } = storeToRefs(useTasksStore());

  // ===================================================================
  // State
  // ===================================================================
  const tanks: ComputedRef<Tank[]> = computed(() => {
    if (!activeTask.value || !isEnvAttrsModifierTask(activeTask.value)) return [];
    return activeTask.value.details.tanks || [];
  });

  // ===================================================================
  // Getters
  // ===================================================================
  const getAttributesOfTank = (key: string): TaskTankAttribute[] => {
    if (!tanks.value || !tanks.value.length) return [];

    const tank = tanks.value.find(t => t.key === key);
    return tank?.attributes || [];
  };

  return {
    // ===================================================================
    // Getters
    // ===================================================================
    getAttributesOfTank,

    // ===================================================================
    // State
    // ===================================================================
    tanks,
  };
}
